import { FC } from "react";

import { formatPhoneNumber } from "src/helpers";
import { PracticeInformationProps } from "./types";



const PracticeInformation: FC<PracticeInformationProps> = ({ title, practice_information }): JSX.Element => {
  return (
    <div className="card">
      <div className="card-header iovera-theme">
        <h4 className="m-0">{title}</h4>
      </div>

      <div className="card-body">
        <div className="row">
            <div className="col-12 col-lg-6">
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <label className="form-label">Name:</label>
                    </div>
                    <div className="col-6">
                        <p>
                            {practice_information ? practice_information.name : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <label className="form-label">Street:</label>
                    </div>
                    <div className="col-6">
                        <p>
                            {practice_information ? practice_information.street : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <label className="form-label">City:</label>
                    </div>
                    <div className="col-6">
                        <p>
                            {practice_information ? practice_information.city : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <label className="form-label">State:</label>
                    </div>
                    <div className="col-6">
                        <p>
                            {practice_information ? practice_information.state : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <label className="form-label">Zip:</label>
                    </div>
                    <div className="col-6">
                        <p>
                            {practice_information ? practice_information.zip : "N/A"}
                        </p>
                    </div>
                </div>
            </div>


            <div className="col-12 col-lg-6">
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <label className="form-label">SOC Type:</label>
                    </div>
                    <div className="col-6">
                        <p>
                            {practice_information ? practice_information.soc || "N/A" : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <label className="form-label">Speciality:</label>
                    </div>
                    <div className="col-6">
                        <p>
                            {practice_information ? practice_information.spaciality || "N/A" : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <label className="form-label">NPI:</label>
                    </div>
                    <div className="col-6">
                        <p>{practice_information ? practice_information.npi : "N/A"}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <label className="form-label">DEA:</label>
                    </div>
                    <div className="col-6">
                        <p>
                            {practice_information ? practice_information.dea || "N/A" : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <label className="form-label">Phone Number:</label>
                    </div>
                    <div className="col-6">
                        <p>
                            {practice_information && practice_information.phone_number ? formatPhoneNumber(practice_information?.phone_number) : "N/A"}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 text-end px-3">
                        <label className="form-label">Fax Number:</label>
                    </div>
                    <div className="col-6">
                        <p>
                            {practice_information && practice_information.fax_number ? formatPhoneNumber(practice_information.fax_number) : "N/A"}
                        </p>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default PracticeInformation;
